import { OverridableToolbarView } from '@bingads-webui/toolbar';
import { SingleViewWrapper } from './single-view-wrapper';
import { INLINE_CHART_TOGGLE_BUTTON_ID } from '../../constant';

export function getUpperToolbar() {
  const toolbarConfig = {
    items: [
      {
        type: 'button',
        id: INLINE_CHART_TOGGLE_BUTTON_ID,
        classes: ['btn', 'chart-icon'],
      }, {
        type: 'dropdown',
        id: 'filter-menu',
      },
    ],
  };

  return new SingleViewWrapper({
    view: new OverridableToolbarView(toolbarConfig),
    rendered: false,
  });
}
